import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import EnhancedToolbar from '../../widgets/Toolbar';
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import EnhancedTable from '../../widgets/ResponsiveTable';
import ViewUtils from '../../ViewUtils';
import { AssessmentHeaderForm } from './AssessmentHeaderForm';
import AlertItem from "../../widgets/AlertItem";

const headCells = [
    { id: 'ProgrammeCode', numeric: false, disablePadding: true, label: 'SAQA Unit Standard Code' },
    { id: "ProgrammeTitle", numeric: false, disablePadding: true, label: "SAQA Unit Standard Title" },
    { id: "Credits", numeric: false, disablePadding: true, label: "Credits" },
    { id: "UnitStandardType", numeric: false, disablePadding: true, label: "Unit Standard Type" },
    { id: "RPL", numeric: false, disablePadding: true, label: "RPL" },
    { id: "PreviouslyAchieved", numeric: false, disablePadding: true, label: "Previously Achieved" },
    { id: "Assessor", numeric: false, disablePadding: true, label: "Assessor" },
    { id: "AssessmentDate", numeric: false, disablePadding: true, label: "Assessment Date" },
    { id: "Moderator", numeric: false, disablePadding: true, label: "Moderator" },
    { id: "ModerationDate", numeric: false, disablePadding: true, label: "Moderation Date" },
    { id: "Status", numeric: false, disablePadding: true, label: "Status" },
    { id: "DateAssessmentCaptured", numeric: false, disablePadding: true, label: "Date Assessment Captured" },
]


const utils = new ViewUtils();
const toolbarRef = React.createRef();
const learnerRef = React.createRef();

class ViewLearnershipAssessment extends Component {

    constructor(props) {
        super(props)
        this.state = {
            model: {
                AssessmentID: null
            },
            selectedUnitStandards: null,
            keyUpSwitch: false,
            updateUSd: false,
            messsageAlert: null,
            messageStyle: null,
            showTable: true,
            searchParameters: [{ Name: "AssessmentID", Value: this.props.location.state.LearnershipID }],
            permissionItem: this.props.location.state.permissionItem
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'cancel', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon', icon: 'CloseIcon' }
                    ]
                },
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'updateUS', label: '', tooltip: 'UPDATE UNIT STANDARDS', icon: 'UpdateIcon', visible: this.state.permissionItem.Edit },
                        { id: 'remove', label: '', tooltip: 'REMOVE SELECTED ASSESSMENTS', icon: "DeleteIcon", visible: this.state.permissionItem.Delete },
                        { id: 'closeoff', label: 'CLOSE OFF', tooltip: 'CLOSE OFF', disabled: true, visible: this.state.permissionItem.Edit },
                        { id: 'qaapproval', label: 'QA APPROVAL', tooltip: 'QA APPROVAL', disabled: true, visible: this.state.permissionItem.Edit }
                    ]
                }
            ]
        };
    }

    handleToolbarButtonClick = (buttonId) => {
        if ("updateUS" === buttonId) {
            this.updateUSDocuments();
        }
        else if ("cancel" === buttonId) {
            this.props.history.push({
                pathname: '/LearnerLearnershipAssessments',
                state: {
                    learnerID: this.props.location.state.LearnerID,
                    learnerNames: this.props.location.state.learnerNames
                }
            });
        } else if ("remove" === buttonId) {
            this.removeAssessments();

        } else if ("closeoff" === buttonId) {
            this.closeOff();

        } else if ("qaapproval" === buttonId) {
            this.qaApproval();

        }
    }

    removeAssessments() {
        const UnitStandardIDs = this.state.selectedUnitStandards.map(e => e.Id);
        let data = {
            UnitStandardIDs: UnitStandardIDs,
            ...this.state.model
        }
        let input = JSON.stringify(data);
        utils.invokeUrl("api/sims/LearnerLearnershipAssessment/RemoveLearnerLearnershipAssessment", this.successCallback, () => { alert(utils.SYSTEM_ERROR_MESSAGE) }, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            body: input
        });
    }

    closeOff() {
        let url = "api/sims/LearnerLearnershipAssessment/CloseOffAssessment?AssessmentID=" + this.props.location.state.LearnershipID;
        utils.invokeUrl(url, (response) => {
            this.successCloseOffandQA(response)
            toolbarRef.current.setButtonDisabled("closeoff", true);
        },
            null,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    }

    qaApproval() {
        let url = "api/sims/LearnerLearnershipAssessment/ApproveAssessment?AssessmentID=" + this.props.location.state.LearnershipID;
        utils.invokeUrl(url, (response) => {
            this.successCloseOffandQA(response)
            toolbarRef.current.setButtonDisabled("qaapproval", true);
        },
            null,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    }

    successCloseOffandQA = (response) => {
        this.setState({
            message: response.Message,
            messageStyle: response.MessageType,
            showTable: false
        }, () => {
            this.setState({
                message: response.Message,
                messageStyle: response.MessageType,
                showTable: true
            })
        });
    }

    handleToolbarButtonClickClose = (buttonId) => {
        if ("cancel" === buttonId) {

        }
    }

    GetQAPermission() {
        let url = "api/sims/LearnerLearnershipAssessment/GetQAPermission?AssessmentID=" + this.props.location.state.LearnershipID;
        utils.invokeUrl(url, (response) => {
            if (response.Result !== "1") {
                toolbarRef.current.setButtonDisabled("qaapproval", true);
            }
            else {
                toolbarRef.current.setButtonDisabled("qaapproval", false);
            }

        },
            null,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    }

    GetClosePermission() {
        let url = "api/sims/LearnerLearnershipAssessment/GetClosePermission?AssessmentID=" + this.props.location.state.LearnershipID;
        utils.invokeUrl(url, (response) => {
            if (response.Result !== "1") {
                toolbarRef.current.setButtonDisabled("closeoff", true);
            }
            else {
                toolbarRef.current.setButtonDisabled("closeoff", false);
            }

        },
            null,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    }

    componentDidMount() {
        this.GetClosePermission();
        this.GetQAPermission();
    }

    successCallback = (response) => {
        this.setState({
            showTable: false,
            message: response.Message, messageStyle: response.MessageType
        }, () => {
            this.setState({ showTable: true, message: response.Message, messageStyle: response.MessageType })
        });
        this.GetQAPermission();
    }

    updateUSDocuments() {
        const UnitStandardIDs = this.state.selectedUnitStandards.map(e => e.Id);
        let data = {
            UnitStandardIDs: UnitStandardIDs,
            ...this.state.model
        }
        let input = JSON.stringify(data);
        utils.invokeUrl("api/sims/LearnerLearnershipAssessment/UpdateLearnerLearnershipAssessment", (response) => {
            this.successCallback(response);
        }, () => { alert(utils.SYSTEM_ERROR_MESSAGE) }, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            body: input
        });
    }

    handleSelectionChange = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedUnitStandards: selection, Message: "" },
                () => {
                    toolbarRef.current.setButtonDisabled("updateUS", selection.length === 0);
                    toolbarRef.current.setButtonDisabled("remove", selection.length === 0);
                }
            )
        }
        else {
            this.setState({ selectedUnitStandards: null, Message: "" },
                () => {
                    toolbarRef.current.setButtonDisabled("updateUS", selection.length === 0);
                    toolbarRef.current.setButtonDisabled("remove", selection.length === 0);
                }
            )
        }
    }

    handleFormValueChange = (values) => {
        let newValues = null;
        if (!utils.isNull(values)) {
            newValues = { ...values };
        }
        if (!utils.isNull(newValues)) {
            if (JSON.stringify(this.state.model) !== JSON.stringify(newValues)) {
                this.setState({
                    model: newValues,
                    Message: ""
                });

                toolbarRef.current.setButtonDisabled("updateUS", true);
                toolbarRef.current.setButtonDisabled("Cancel", true);
                toolbarRef.current.setButtonDisabled("remove", true);
            }
        }
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <p className="breadcrumbs">
                    {`Learner > Update Learnership Assessment > ${this.props.location.state.learnerNames}`}
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                {this.state.showTable === true && (
                    <AssessmentHeaderForm
                        ref={learnerRef}
                        viewRef={this}
                        id={this.props.location.state.LearnershipID}
                        valueChangeHandler={(values) => this.handleFormValueChange(values)}
                        controllerName={"LearnerLearnershipAssessment"}
                        dataURL='api/sims/LearnerLearnershipAssessment/GetLearnerLearnershipAssessmentHeaderDetails'
                        IsModCompulsory={false} ShowNYC={true} />
                )}
                <td>
                    <EnhancedToolbar
                        ref={toolbarRef}
                        highlight={false}
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        config={this.toolbarConfig} />
                </td>

                <div>
                    {this.state.showTable === true && (
                        <EnhancedTable
                            multiSelect={true}
                            headCells={headCells}
                            dataUrl="api/sims/LearnerLearnershipAssessment/getLearnerLearnershipAssessmentDetails"
                            onSelectionChange={(selection) => { this.handleSelectionChange(selection) }}
                            searchParameters={this.state.searchParameters} paged={true} />
                    )}
                </div>
            </ViewContainer>
        );
    }
}

export default withRouter(
    connect()(ViewLearnershipAssessment)
);